export const getApiUrl = () => {
  if (window.APP_CONFIG?.API_URL) {
    return window.APP_CONFIG.API_URL;
  }
};